import React, { useEffect } from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import useStore from '../../store/useStore';
import { authApi } from '../../services/authApi';

const Logout = () => {
  const navigate = useNavigate();
  const { logout } = useStore();

  useEffect(() => {
    (async () => {
      try { await authApi.logout(); } catch { /* ignore */ }
      logout();
      const t = setTimeout(() => navigate('/login', { replace: true }), 600);
      return () => clearTimeout(t);
    })();
  }, [logout, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900 p-4">
      <Result
        status="success"
        title="You have been signed out"
        subTitle="Redirecting to login..."
        extra={<Button type="primary" onClick={() => navigate('/login', { replace: true })}>Go to Login</Button>}
      />
    </div>
  );
};

export default Logout;
